import { render, staticRenderFns } from "./TrainingQuestionCard.vue?vue&type=template&id=4ce3fb4c&scoped=true"
import script from "./TrainingQuestionCard.vue?vue&type=script&lang=js"
export * from "./TrainingQuestionCard.vue?vue&type=script&lang=js"
import style0 from "./TrainingQuestionCard.vue?vue&type=style&index=0&id=4ce3fb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce3fb4c",
  null
  
)

export default component.exports